import React, { FC, useEffect } from 'react'
import { Outlet, useNavigate } from 'react-router-dom'
import { useReactiveVar } from '@apollo/client'

import { currentUserVar } from 'modulesCommon/store'

export const AdminLayout: FC = () => {
  const currentUser = useReactiveVar(currentUserVar)

  const navigate = useNavigate()

  useEffect(() => {
    if (currentUser.abilities) {
      if (currentUser.abilities.canViewAdminTab !== true) navigate('/feed', { replace: true })
    }
  }, [currentUser, navigate])

  return (
    <Outlet />
  )
}
